'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './header.component';
import dynamic from 'next/dynamic';

const DynamicHeaderComponent: ComponentType<Props> = dynamic(() => import('./header.component'));

export default DynamicHeaderComponent;

export function calculateHeaderPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 162 },
    { sinceWidth: 768, height: 192 }
  ];

  return {
    heightSinceWidth
  };
}
